import { customerOrganisation } from "./enterpriseCustomer";
import { useTranslation } from "@privacy/translations";
import { useQuery } from "@tanstack/react-query";
import { DynamicGrid } from "../dynamicGrid";
import { DynamicHistory } from "../dynamicHistory";
import { Drawer } from "../shared/Drawer";
import {
  sharedProcessingByIdQueryOptions,
  sharedProcessingFormQueryOptions,
  sharedProcessingHistoryQueryOptions,
  sharedProcessingSharedOrganisationsQueryOptions,
} from "../api/sharedProcessings";
import { SharedProcessingDrawerHeader } from "./SharedProcessingDrawerHeader";
import { RegistrationCustomEntry } from "../shared/RegistrationCustomEntry";
import { useCurrentCustomer } from "../root/CurrentOrganisationProvider";

export const SharedProcessingHistoryDrawer = () => {
  const sharedProcessingId = DynamicGrid.useSelectedRowId();
  const { t } = useTranslation();
  const historyQuery = useQuery(sharedProcessingHistoryQueryOptions(sharedProcessingId));
  const sharedProcessingQuery = useQuery(sharedProcessingByIdQueryOptions(sharedProcessingId));
  const sharedOrganisationsQuery = useQuery(sharedProcessingSharedOrganisationsQueryOptions(sharedProcessingId));
  const formQuery = useQuery(sharedProcessingFormQueryOptions());
  const currentCustomer = useCurrentCustomer();
  const organisationName = (tenantId?: string) =>
    sharedOrganisationsQuery.data?.find(organisation => organisation.organisationId === tenantId)?.organisationName ??
    customerOrganisation(currentCustomer, tenantId)?.name ??
    (tenantId && tenantId !== currentCustomer.id ? t("SharedProcessing.History.FormerOrganisation") : undefined);

  return (
    <DynamicGrid.Drawer>
      {(() => {
        if (!sharedProcessingQuery.data) return <Drawer.Loading />;

        return (
          <>
            <SharedProcessingDrawerHeader
              sharedProcessing={sharedProcessingQuery.data}
              activeTab="history"
              statusIndicator={"hidden"}
            />

            {!historyQuery.data ? (
              <Drawer.Loading />
            ) : (
              <DynamicHistory.Entries
                historyEntries={historyQuery.data.history.filter(
                  entry => !("customType" in entry && entry.customType === "sharedRegistrationChangedByCustomer")
                )}
                renderCustomEntry={entry => (
                  <RegistrationCustomEntry
                    entry={entry}
                    form={formQuery.data}
                    organisation={organisationName(entry.tenantId)}
                  />
                )}
              />
            )}
          </>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};
